import { Service } from '@/services/api';
import type { RecentVisit, RecentVisitEntityType } from '@/types/v2/RecentVisit';

class RecentVisitService extends Service {
  async list(entityType: RecentVisitEntityType, limit: number): Promise<RecentVisit[]> {
    return this.get<RecentVisit[]>('/v2/recent-visits', { entityType, limit }).then(this.handleResponse);
  }

  // Fire-and-forget: `post` resolves failures instead of rejecting, and a lost visit must never surface to the user.
  async record(entityType: RecentVisitEntityType, entityId: number): Promise<void> {
    await this.post('/v2/recent-visits', { entityType, entityId });
  }
}

export const recentVisitService = new RecentVisitService();
